import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layout/DashboardLayout";
import styles from "../../styles/pages/trading-assistant/index.module.sass";
import { useDispatch, useSelector } from "react-redux";
import {
  getTradeAssistant,
} from "../../redux/trading-assistant/actions";
import { useNavigate, useParams } from "react-router-dom";
import Assistant from "../../components/trading-assistant/Assistant";
import usePageTitle from "../../hooks/usePageTitle";
import useServiceStatus from "../../hooks/useServiceStatus";

const Index = () => {
  const dispatch = useDispatch();
  const {
    main: { userData },
    tradingAssistant: {
      loading,
      error,
      aiMarketType,
      tradeAssistant,
      allTradeSuggestionData,
    },
    profile: { profileData },
  } = useSelector((state) => state);

  const { isActive } = useServiceStatus("aiAssistant");

  const navigate = useNavigate();
  const { section } = useParams();
  const [cache, setCache] = useState({
    p1: false,
    p2: false,
    s1: false,
    s2: false,
    3: false,
  });

  const [modeKey, setModeKey] = useState("");
  usePageTitle("AI Assistant");

  useEffect(() => {
    if (
      userData?.["cognito:username"] &&
      allTradeSuggestionData?.length === 0 &&
      !tradeAssistant?.risk_taking
    ) {
      if (
        section === "assistant" &&
        !cache?.["3"] &&
        profileData?.email
      ) {
        dispatch(
          getTradeAssistant(
            userData?.["cognito:username"],
            userData?.["custom:custom_username"],
            "primary",
            aiMarketType,
            isActive,
          ),
        );
        // dispatch(
        //   getAllTradeSuggestion(
        //     userData?.["custom:custom_username"],
        //     userData?.["cognito:username"],
        //     aiMarketType,
        //     isActive,
        //   ),
        // );
        setCache((prev) => ({
          ...prev,
          3: true,
        }));
      }
    }
  }, [
    cache,
    dispatch,
    section,
    userData,
    aiMarketType,
    profileData,
    isActive,
    allTradeSuggestionData,
    tradeAssistant,
  ]);

  useEffect(() => {
    if (!section) {
      navigate("/ai-assistant/assistant");
    }
  }, [navigate, section]);

  return (
    <DashboardLayout aiLayout loading={loading} error={error} hasDemo>
      <div className={styles.tradeAssistantWrapper}>
        <div className={styles.main}>
          {section === "assistant" && (
            <Assistant
              portfolio="primary"
              market={aiMarketType}
              setAIMode={setModeKey}
              aiMode={modeKey}
            />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Index;
